import Image from 'next/image';
import { toast } from 'sonner';

// TODO: 視未來需求再增加 Loading toast
type ToastType = 'success' | 'error' | 'info' | 'warning';
type ToastOptions = {
  title?: string;
  description?: string;
  duration?: number;
};

const TOAST_CONFIG = {
  duration: 10000,
  icon: {
    success: '/icons/check-circle-green.svg',
    error: '/icons/attention-triangle-red.svg',
    info: '/icons/question-circle-sky.svg',
    warning: '/icons/attention-circle-tangerine.svg',
  },
  decorationColor: {
    success: 'after:bg-success',
    error: 'after:bg-error',
    info: 'after:bg-info',
    warning: 'after:bg-warning',
  },
  trigger: {
    success: toast.success,
    error: toast.error,
    info: toast.info,
    warning: toast.warning,
  },
} as const;

export const toastWrapper = (type: ToastType, options: ToastOptions = {}) => {
  const {
    title = type.charAt(0).toUpperCase() + type.slice(1),
    description,
    duration = TOAST_CONFIG.duration,
  } = options;

  const toastTrigger = TOAST_CONFIG.trigger[type];
  return toastTrigger(title, {
    description,
    duration,
    className: TOAST_CONFIG.decorationColor[type],
    icon: <Image alt={`${type}-toast-icon`} src={TOAST_CONFIG.icon[type]} width={32} height={32} />,
  });
};

const toastPopper = {
  success: (options: ToastOptions) => toastWrapper('success', options),
  error: (options: ToastOptions) => toastWrapper('error', options),
  info: (options: ToastOptions) => toastWrapper('info', options),
  warning: (options: ToastOptions) => toastWrapper('warning', options),
};

export default toastPopper;
